import { EmptyObject } from '@reduxjs/toolkit'

import { commonAPI } from '@redux/api/common.api'

import { URLS } from '@constants'

import {
  GanttCopyDataPayload,
  GanttFormValues,
  GanttFormValuesBack,
} from '@gantt/components/GanttCreateOrEdit'
import { transformFetchGanttByIdResponse } from '@gantt/helpers'
import { GanttConfig } from '@gantt/types'

export const modelGanttAPI = commonAPI.injectEndpoints({
  endpoints: build => ({
    createGantt: build.mutation<number, GanttFormValues>({
      query: gantt => ({
        url: URLS.FRONT_CFG + '/gantChart',
        method: 'POST',
        body: gantt,
      }),
      invalidatesTags: ['AllGantt', 'AllViews', 'SingleGantt'],
    }),
    fetchAllGantt: build.query<GanttConfig[], EmptyObject>({
      query: () => ({
        url: URLS.FRONT_CFG + '/gantChart/all',
      }),
      providesTags: ['AllGantt'],
    }),
    fetchGanttById: build.query<GanttFormValuesBack, string | undefined>({
      query: id => ({
        url: URLS.FRONT_CFG + `/gantChart/config/${id}`,
      }),
      providesTags: ['SingleGantt'],
      transformResponse: transformFetchGanttByIdResponse,
    }),
    updateGantt: build.mutation<GanttFormValues, GanttFormValues>({
      query: gantt => ({
        url: URLS.FRONT_CFG + '/gantChart',
        method: 'POST',
        body: gantt,
      }),
      invalidatesTags: ['AllGantt', 'SingleGantt'],
    }),
    copyGantt: build.mutation<number, GanttCopyDataPayload>({
      query: gantt => ({
        url: URLS.FRONT_CFG + '/gantChart/copy',
        method: 'POST',
        body: gantt,
      }),
      invalidatesTags: ['AllGantt', 'SingleGantt'],
    }),
    deleteGanttById: build.mutation<void, string | number>({
      query: code => ({
        url: URLS.FRONT_CFG + `/gantChart/${code}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllGantt'],
    }),
  }),
})

export const {
  useCreateGanttMutation,
  useFetchAllGanttQuery,
  useFetchGanttByIdQuery,
  useUpdateGanttMutation,
  useDeleteGanttByIdMutation,
  useCopyGanttMutation,
} = modelGanttAPI
